import { render, staticRenderFns } from "./Mitarbeiter.vue?vue&type=template&id=2a84b7f9&"
import script from "./Mitarbeiter.vue?vue&type=script&lang=js&"
export * from "./Mitarbeiter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports